import { createFileRoute } from '@tanstack/react-router'

import DesaPage from '@/components/pages/backoffice/_klb-penyuluh/_desa/containers/DesaPage'

export const Route = createFileRoute('/_backoffice/klb-penyuluh/desa/')({
  component: DesaPage
})
